'use client';
import { AgencyCheckmarkIcon } from '@curology/ui-components-web/react/Icon/icons/AgencyCheckmarkIcon';
import { CheckmarkIcon } from '@curology/ui-components-web/react/Icon/icons/CheckmarkIcon';
import clsx from 'clsx';
import React from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';

const ImagePickerItem = ({
  // @ts-expect-error - TODO: broken by noImplicitAny
  question,
  // @ts-expect-error - TODO: broken by noImplicitAny
  choice,
  // @ts-expect-error - TODO: broken by noImplicitAny
  handleOnClick,
  // @ts-expect-error - TODO: broken by noImplicitAny
  handleKeyDownChange,
}) => {
  const { brand } = useFlowContext();

  const checkmarkIcon =
    brand === 'agency' ? (
      <AgencyCheckmarkIcon size="sm" />
    ) : (
      <CheckmarkIcon className="cur-text-surface-brand-accent" size="sm" />
    );

  if (!choice.visible) {
    return null;
  }

  // SurveyJS always requires a value, so we use 'hidden' to indicate that the image should not be shown
  const hasImage = choice.imageLink !== 'hidden';

  return (
    <div
      key={choice.value}
      onClick={() => handleOnClick(choice)}
      onKeyDown={() => handleKeyDownChange(event, choice)}
    >
      <input
        className="cur-peer cur-sr-only"
        id={question.getItemId(choice)}
        type="radio"
        tabIndex={0}
        name={question.questionName}
        defaultChecked={question.isItemSelected(choice)}
        value={choice.value}
      />
      <label
        className={clsx(
          'cur-flex cur-cursor-pointer cur-ring-4 peer-focus-visible:cur-ring-offset-border-brand-selected peer-focus-visible:cur-ring-offset-2',
          question.isItemSelected(choice)
            ? 'cur-ring-surface-brand'
            : 'cur-bg-surface-neutral cur-ring-transparent',
          question.descriptionOrientation === 'horizontal'
            ? 'cur-w-full cur-h-[90px]'
            : 'cur-flex-col',
          question.isItemSelected(choice) &&
            question.descriptionOrientation === 'horizontal'
            ? 'cur-bg-surface-highlight'
            : 'cur-bg-surface-neutral',
        )}
      >
        {hasImage && (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            className={clsx(
              question.descriptionOrientation === 'horizontal'
                ? 'cur-h-[90px]'
                : '',
              choice.description ? 'cur-h-[156px]' : 'cur-h-[142px]',
            )}
            alt={choice.description}
            src={choice.imageLink}
          />
        )}
        <div
          className={clsx(
            'cur-flex cur-flex-col',
            choice.description ? 'cur-h-[153px]' : 'cur-py-[9px] cur-pl-3',
            question.descriptionOrientation === 'horizontal'
              ? 'cur-h-[90px] cur-w-full cur-justify-center'
              : 'cur-gap-y-1',
            hasImage ? 'cur-p-4' : 'cur-px-4 cur-py-5',
          )}
        >
          <div
            className={clsx(
              'cur-font-bold cur-leading-5',
              choice.description ? '' : 'cur-text-[14px]',
              question.descriptionOrientation === 'horizontal'
                ? 'cur-flex cur-justify-between'
                : '',
            )}
          >
            {choice.text}
            {question.descriptionOrientation === 'horizontal' &&
              question.isItemSelected(choice) && (
                <div className="">{checkmarkIcon}</div>
              )}
          </div>
          <div
            className={clsx(
              'cur-font-body cur-text-[14px]',
              question.descriptionOrientation === 'horizontal'
                ? 'cur-text-meta cur-leading-4'
                : 'cur-leading-6',
            )}
          >
            {choice.description}
          </div>
        </div>
      </label>
    </div>
  );
};

export default ImagePickerItem;
